import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";

const DataTableProductionOrder = ({ listProductionOrder }) => {
  const navigate = useNavigate();

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
 
 
  function buttonDetailsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-dark btn-sm"
        onClick={() => {
          localStorage.setItem("idPO", row.id);
          navigate(`/production-orders-details`);
        }}
      >
        <i class="fas fa-folder"></i>
      </button>
      
    );
  }

   
  function buttonBontravailFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-dark btn-sm"
        onClick={() => {
          localStorage.setItem("idPO", row.id);
          navigate(`/work-orders-po`);
        }}
      >
        <i class="fas fa-folder"></i>
      </button>
      
    );
  }

  const columns = [
    {
      dataField: "code",
      text: "Réference",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "name",
      text: "Libellé",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "dateCreation",
      text: "DC",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "scheduledDate",
      text: "Date limite",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "id",
      text: "Info",
      formatter: buttonDetailsFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "id",
      text: "Bons de travails",
      formatter: buttonBontravailFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];


  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les ordres de production</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="factureId"
          data={listProductionOrder}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );
};
export default DataTableProductionOrder;
